module.exports = __webpack_public_path__ + "static/media/cricket.9d3cf7b9.wav";